import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import {isFloat} from 'validator';
import {List} from "immutable";
import moment from 'moment';

// Components
import Select from "../../components/common/virtualized-select";
import DateInput from '../../components/common/date-input';

// Actions
import { createProject, cleanProjects } from "../../actions/projects";
import {getSalesOrders, cleanSalesOrders} from "../../actions/sales-orders";
import {Map} from "immutable/dist/immutable";

class NewProject extends Component {
    constructor(props) {
        super(props);

        this.state = {
            project_code: '',
            document_date: moment(),
            name: '',
            description: '',
            key: '',
            order: -1,
            target_total: '',
            target_margin: '',
            canSubmit: false
        };
    }
    componentDidMount() {
        this.props.getSalesOrders({
            projection: 'order_code',
            deleteVirtuals: true
        });
    }

    componentWillUnmount() {
        this.props.cleanProjects();
    }

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateProject);
    };

    validateProject = () => {
        if (
            this.state.project_code !== '' &&
            this.state.document_date.isValid() &&
            this.state.name !== '' &&
            this.state.target_margin !== ''
        ) {
        this.setState({ canSubmit: true });
        }
        else {
            this.setState({ canSubmit: false });
        }
    };

    handleCreateClick = () => {
        this.props.createProject({
            project_code: this.state.project_code,
            name: this.state.name,
            document_date: this.state.document_date,
            ...(this.state.description !== '') ? { description: this.state.description } : '',
            ...(this.state.key !== '') ? { key: this.state.key } : '',
            ...(this.state.order !== -1) ? { order: this.state.order } : '',
            ...(this.state.target_total !== '' || this.state.target_margin !== '')
                ? {
                    statistics: {
                        ...(this.state.target_total !== '') ? { target_total: this.state.target_total } : '',
                        ...(this.state.target_margin !== '') ? { target_margin: this.state.target_margin } : ''
                    }
                }
                : ''
        }, {
            projection: 'project_code name document_date description key order statistics status',
            calculateStatistics: 'projects',
            calcIsAsync: true,
            populateRefs: [{
                field: 'order',
                projection: 'order_code'
            }],
            deleteVirtuals: true
        });
        this.props.history.push('/proyectos');
    };

    render() {

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/proyectos">Proyectos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Proyecto</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/proyectos') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.handleCreateClick() }
                                disabled={!this.state.canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de proyecto *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.project_code}
                                                    onChange={ (event) => this.onChangeInput('project_code', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha de proyecto *</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            document_date: selectedDate
                                                        });
                                                    }}
                                                    value={this.state.document_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Nombre de proyecto *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.name}
                                                    onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Descripción</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.description}
                                                    onChange={ (event) => this.onChangeInput('description', event.target.value) }
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Tecla</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.key}
                                                    onChange={(event) => this.onChangeInput('key', event.target.value)}
                                                    disabled={this.props.mode === 'view'}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Pedido de venta asociado</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.props.salesOrders.toJS()}
                                                    value={this.state.order}
                                                    labelKey="order_code"
                                                    valueKey="_id"
                                                    matchProp="order_code"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    removeSelected={false}
                                                    onChange={(selectedValue) => {
                                                        if (selectedValue) {
                                                            this.onChangeInput('order', selectedValue._id)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <h4>Valores objetivo</h4>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Importe total objetivo</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.target_total}
                                                    onChange={ (event) => {
                                                        const target_total = event.target.value;
                                                        if (isFloat(target_total) || target_total === '') {
                                                            this.onChangeInput('target_total', target_total);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Margen objetivo (%) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.target_margin}
                                                    onChange={ (event) => {
                                                        let target_margin = event.target.value;
                                                        if (target_margin === '') target_margin = '0';
                                                        if (isFloat(target_margin)) {
                                                            this.onChangeInput('target_margin', target_margin);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const salesOrdersReducer = state.salesOrders;

    // SalesOrders
    let salesOrders = salesOrdersReducer.get('payload') || List([]);
    if (!(salesOrders instanceof List)) salesOrders = List([]);
    salesOrders = salesOrders.insert(0, Map({
        _id: -1,
        order_code: 'Selecciona un pedido de venta'
    }));

    return {
        salesOrders
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSalesOrders: (query) => dispatch(getSalesOrders(query)),
        createProject: (project, options) => dispatch(createProject(project, options)),
        cleanProjects: () => dispatch(cleanProjects()),
        cleanSalesOrders: () => dispatch(cleanSalesOrders())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewProject);



// WEBPACK FOOTER //
// ./src/containers/projects/NewProject.js